<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Eixo</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Eixo"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
          <v-col sm="6">
            <v-text-field
              label="Multiplicador"
              name="multiplicador"
              type="number"
              required
              v-model="payload.multiplicador"
            ></v-text-field>
          </v-col>
           <v-row>
          <v-col sm="12">
            <v-text-field
              label="Descrição"
              name="descricao"
              type="text"
              required
              v-model="payload.descricao"
            ></v-text-field>
          </v-col>
          </v-row>
        </v-row>
        <v-row>
          <v-col sm="6">
            <v-checkbox
              v-model="payload.nacional"
              id="nacional"
              color="primary"
              label="Nacional"
            >
            </v-checkbox>
          </v-col>
          <v-col sm="6">
            <v-checkbox
              v-model="payload.obrigatorio"
              id="obrigatorio"
              color="primary"
              label="Obrigatório"
            >
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close()"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { eixoAPI } from '../API/eixoAPI'

export default {
  name: 'AppModalInsertEixo',
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  components: {},
  data () {
    return {
      payload: {},
      dialog: false
    }
  },
  mounted () {
    this.payload = {}
    if (this.object && this.edit === true) {
      this.payload = { ...this.object }
    }
  },
  methods: {
    onConfirm () {
      this.payload = {
        ...this.payload,
        multiplicador: parseFloat(this.payload.multiplicador),
        nacional: this.payload.nacional ? 1 : 0,
        obrigatorio: this.payload.obrigatorio ? 1 : 0
      }

      if (this.edit === true) {
        eixoAPI
          .update(this.payload)
          .then((resp) => {
            this.dialog = false
            this.$emit('on-save')
          })
          .catch()
        this.payload = {}
      } else {
        eixoAPI
          .create(this.payload)
          .then((resp) => {
            this.dialog = false
            this.$emit('on-save')
          })
          .catch()
        this.payload = {}
      }
    },
    close () {
      this.payload = {}
      this.dialog = false
    }
  }
}
</script>
